import styled from 'styled-components';

export const CarouselContainer = styled.div<{ size?: 'small' | 'medium' | 'big' }>`
  position: relative;
  width: 100%;
  height: ${props => {
    switch (props.size) {
      case 'small': return '136px';
      case 'medium': return '300px';
      case 'big':
      default: return '380px';
    }
  }};
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
  
  @media (max-width: 1024px) {
    height: ${props => {
      switch (props.size) {
        case 'small': return '106px';
        case 'medium': return '270px';
        case 'big':
        default: return '350px';
      }
    }};
    margin-bottom: 30px;
  }
  
  @media (max-width: 768px) {
    height: ${props => {
      switch (props.size) {
        case 'small': return '106px';
        case 'medium': return '270px';
        case 'big':
        default: return '350px';
      }
    }};
    border-radius: 8px;
    margin-bottom: 25px;
  }
  
  @media (max-width: 480px) {
    height: ${props => {
      switch (props.size) {
        case 'small': return '106px';
        case 'medium': return '270px';
        case 'big':
        default: return '350px';
      }
    }};
    border-radius: 6px;
    margin-bottom: 20px;
  }
`;

export const SlideContainer = styled.div<{ currentSlide: number }>`
  display: flex;
  width: 100%;
  height: 100%;
  transform: translateX(-${props => props.currentSlide * 100}%);
  transition: transform 0.5s ease-in-out;
`;

export const SlideContent = styled.div<{ active: boolean; clickable?: boolean }>`
  position: relative;
  min-width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
`;

export const SlideImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const SlideInfo = styled.div<{ size?: 'small' | 'medium' | 'big' }>`
  position: absolute;
  left: 80px;
  top: ${props => {
    switch (props.size) {
      case 'small': return '50%';
      case 'medium': return '70%';
      case 'big':
      default: return '70%';
    }
  }};
  transform: translateY(-50%);
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  max-width: 500px;
  
  @media (max-width: 1024px) {
    left: 80px;
    max-width: 450px;
  }
  
  @media (max-width: 768px) {
    left: 60px;
    max-width: 350px;
  }
  
  @media (max-width: 480px) {
    left: 60px;
    max-width: none;
  }
`;

export const SlideTitle = styled.h1<{ size?: 'small' | 'medium' | 'big' }>`
  font-size: ${props => {
    switch (props.size) {
      case 'small': return '1.8rem';
      case 'medium': return '2.2rem';
      case 'big':
      default: return '2.5rem';
    }
  }};
  font-weight: 700;
  margin-bottom: 10px;
  line-height: 1.2;
  
  @media (max-width: 1024px) {
    font-size: ${props => {
      switch (props.size) {
        case 'small': return '1.6rem';
        case 'medium': return '2rem';
        case 'big':
        default: return '2.2rem';
      }
    }};
  }
  
  @media (max-width: 768px) {
    font-size: ${props => {
      switch (props.size) {
        case 'small': return '1.4rem';
        case 'medium': return '1.6rem';
        case 'big':
        default: return '1.8rem';
      }
    }};
    margin-bottom: 8px;
  }
  
  @media (max-width: 480px) {
    font-size: ${props => {
      switch (props.size) {
        case 'small': return '1.2rem';
        case 'medium': return '1.3rem';
        case 'big':
        default: return '1.5rem';
      }
    }};
    margin-bottom: 6px;
  }
`;

export const SlideButton = styled.a`
  display: inline-block;
  background: var(--primary);
      &:hover {
        background: var(--primary_light);
      }
  color: white;
  padding: 12px 30px;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(255, 107, 107, 0.4);
  }
`;

export const NavigationButton = styled.button<{ position: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${props => props.position}: 20px;
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
  
  &:hover {
    background: white;
    transform: translateY(-50%) scale(1.1);
  }
  
  @media (max-width: 768px) {
    ${props => props.position}: 15px;
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
  
  @media (max-width: 480px) {
    ${props => props.position}: 10px;
    width: 35px;
    height: 35px;
    font-size: 18px;
    background: rgba(255, 255, 255, 0.8);
  }
`;

export const DotsContainer = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
`;

export const Dot = styled.button<{ active: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  background: ${props => props.active ? 'white' : 'rgba(255, 255, 255, 0.5)'};
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: white;
    transform: scale(1.2);
  }
`;
